import React from 'react';
import { useSelector } from 'react-redux';
import LanguageItem from './LanguageItem';
import CustomScrollbars from '../../utils/CustomScrollbars';

const LanguageSwitcher = ({switchLanguage, handleRequestClose}) => {
  const { language } = useSelector(({settings}) => settings);
  
  return (
    <CustomScrollbars className="messages-list language-list scrollbar" style={{height: 230}}>
      <ul className="list-unstyled">
        { language.length > 0 && language.map(lang => <LanguageItem key={lang.id} language={lang}
            handleRequestClose={handleRequestClose} switchLanguage={switchLanguage}/>)
        }
      </ul>
    </CustomScrollbars>
  )
};

export default LanguageSwitcher;

